import { MasterDataCommon } from './../master-data.common';
import { element } from 'protractor';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MasterDataService } from 'src/app/services/master-data.service';
import { FormBuilder, Validators, FormGroup, FormArray, FormControl } from '@angular/forms';
import { NgbModal, NgbTabset } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';
import { CommonMessageService } from 'src/app/services/common-message.service';

@Component({
  selector: 'app-manage-client',
  templateUrl: './manage-client.component.html',
  styleUrls: ['./manage-client.component.css']
})
export class ManageClientComponent implements OnInit {
  formObj:any;
  formObjList:any;
  formStatus:any;
  formSubmitted=false;

  chargableToClientList=[{id:'1',name:'Yes',value:true},{id:'2',name:'No',value:false}];
  ediaryStatusList : any;
  legalStatusList : any;
  sectorList : any;
  branchList : any;

  assignmentList :any;
  locationList :any;
  partnerList :any;
  checkList:any;

  formErrors = MasterDataCommon.clientFormErrors;
  formValidationMessages = MasterDataCommon.clientFormValidationMessages;

  @ViewChild('modalContent') private modalContent;
  @ViewChild('tabsetChecklist') private tabsetChecklist : NgbTabset;
  showChecklist=false;

  constructor(private masterDataService:MasterDataService,private fb: FormBuilder,private modalService: NgbModal,
    private commonMessageService:CommonMessageService) { }

  ngOnInit(): void {
    this.formStatus='view';
    this.initForm();
    this.loadAssignments();
    // When any of the form control value in employee form changes
    // our validation function logValidationErrors() is called
    this.formObj.valueChanges.subscribe((data) => {
    this.logValidationErrors(this.formObj);
    });
  }


  // Initialize Dropdown Lists

  loadAssignments(){
    this.masterDataService.getAssignments()
    .subscribe(res => {
      console.log(res);
      this.assignmentList = res;
      this.loadLocation();
    });
  }

  loadLocation(){
    this.masterDataService.getLocations()
    .subscribe(res => {
      console.log(res);
      this.locationList = res;
      this.loadPartners();
    });
  }

  loadPartners(){
    this.masterDataService.getPartners()
    .subscribe(res => {
      console.log(res);
      this.partnerList = res;
      // this.partnerList.forEach((element,key) => {
      //   element.id=key;
      // });
      this.loadBranch();
    });
  }

  loadBranch(){
    this.masterDataService.getBranch()
    .subscribe(res => {
      console.log(res);
      this.branchList = res;
      this.loadSector();
    });
  }

  loadSector(){
    this.masterDataService.getSectors()
    .subscribe(res => {
      console.log(res);
      this.sectorList = res;
      this.loadEdiaryStatus();
    });
  }

  loadEdiaryStatus(){
    this.masterDataService.getEdiaryStatus()
    .subscribe(res => {
      console.log(res);
      this.ediaryStatusList = res;
      this.loadLegalStatus();
    });
  }

  loadLegalStatus(){
    this.masterDataService.getLegalStatus()
    .subscribe(res => {
      console.log(res);
      this.legalStatusList = res;
      // this.loadClients();
    });
  }

  // loadClients(){
  //   this.masterDataService.getClients()
  //   .subscribe(res => {
  //     console.log(res);
  //     this.formObjList = res;
  //     this.loadChecklist();
  //   });
  // }

  loadChecklist(){
    this.masterDataService.getCheckList()
    .subscribe(res => {
      console.log(res);
      this.checkList = res;
      this.checkList.forEach((element,key) => {
      element.isRequired=false;
      element.remark="";
      });
    });
  }

  // Main Modal Action
  openModal(status) {
    this.formStatus = status;
    this.modalService.open(this.modalContent, {ariaLabelledBy: 'modal-basic-title',size: 'xl',windowClass : "animate__animated animate__slideInUp animate__faster"}).result.then((result) => {
    }, (reason) => {
    });
  }

  closeModal() {
    this.resetModalForm();
    this.modalService.dismissAll();
  }

  resetModalForm(){
    this.showChecklist=false;
    this.formSubmitted = false;
    this.formObj.reset();
  }

  resetModalCheckListForm(){
    this.showChecklist =false;
    this.clientChecklistForm.reset();
    this.clientChecklistForm = {};
  }

  compareItems(i1, i2) {
    return i1 && i2 && i1.id===i2.id;
  }

  // Form Object
  initForm(){
    this.formObj = this.fb.group({
      id : ['', []],
      name : ['', [Validators.required]],
      email : ['', [Validators.required,Validators.email]],
      pan : ['', [Validators.required]],
      address: ['',[Validators.required]],
      ediaryStatus :  [null, [Validators.required]],
      legalStatus :  [null, [Validators.required]],
      branch : [null, [Validators.required]],
      sector : [null, [Validators.required]],
      alias : ['', [Validators.required]],
      chargeableToClient :  ['', [Validators.required]],
      gstNumber :  ['', [Validators.required]],
      principalPlaceOfBusiness :  ['', [Validators.required]],
      partners :  this.fb.array([
        this.addPartnerFormGroup()
      ]),
      clientLocations :  this.fb.array([
        this.addClientLocationFormGroup()
      ]),
    });
  }

  addPartnerButtonClick(){
    (<FormArray>this.formObj.get('partners')).push(this.addPartnerFormGroup());
  }

  addPartnerFormGroup(): FormGroup {
    return this.fb.group({
     id: ['', Validators.required],
     assignments: ['', Validators.required]
   });
 }

  removePartnerButtonClick(index: number): void {
    const formArray = <FormArray>this.formObj.get('partners');
    formArray.removeAt(index);
    formArray.markAsDirty();
    formArray.markAsTouched();
  }

  addLocationButtonClick(){
    (<FormArray>this.formObj.get('clientLocations')).push(this.addClientLocationFormGroup());
  }

  addClientLocationFormGroup(): FormGroup {
    return this.fb.group({
      id: ['', Validators.required],
      distance: ['', Validators.required],
      amount: ['', Validators.required]
    });
  }

  removeClientLocationButtonClick(index: number): void {
    const formArray = <FormArray>this.formObj.get('clientLocations');
    formArray.removeAt(index);
    formArray.markAsDirty();
    formArray.markAsTouched();
  }




 // ----------------------------





  // Form Operations
  // getDisabledAssignments(){
  //   console.log(this.formObj.value)
  //   this.formObj.value.partners.forEach(element1 => {
  //     console.log(element1);
  //     if(element1.assignments){
  //       element1.assignments.forEach((element2,index2) => {
  //         var i = this.assignmentList.findIndex(item => item.id === element2.id);
  //         this.assignmentList[i].disabled=true;;
  //       });
  //     }
  //   });
  // }
  invalidPartnerAssignmentsList:any;
  validateAssignments(){
    console.log(this.formObj.value);
    this.invalidPartnerAssignmentsList = [];
    var arrayControl = this.formObj.get('partners') as FormArray;
    this.formObj.value.partners.forEach((element,key) => {
          if(key<this.formObj.value.partners.length-1){
            var currentPartner = element;
            console.log(currentPartner);
            var nextPartner =  this.formObj.value.partners[key+1];
            console.log(nextPartner);
            let intersection = currentPartner.assignments.filter(x => nextPartner.assignments.includes(x));
            console.log(intersection);
            if(intersection.length>0){
              this.invalidPartnerAssignmentsList.push(key);
              this.invalidPartnerAssignmentsList.push(key+1);
            }
          }
      });
    console.log(this.invalidPartnerAssignmentsList)
    if(this.invalidPartnerAssignmentsList.length>0){
        this.invalidPartnerAssignmentsList.forEach((element,key) => {
          var item = arrayControl.at(element) as FormGroup;
          console.log(item);
          item.controls['assignments'].setErrors({'incorrect': true});
        });
      }else{
        this.formObj.value.partners.forEach((element,key) => {
          var item = arrayControl.at(key) as FormGroup;
          item.controls['assignments'].setErrors({'incorrect': null});
          item.controls['assignments'].updateValueAndValidity();
        })
      }

  }

  // checkInvalidPartner(index){
  //   if( this.formSubmitted){
  //     this.invalidPartnerAssignmentsList.forEach((element,key) => {
  //       if(index==element){
  //         return true;
  //       }else{
  //        return false;
  //       }
  //      })
  //   }
  // }

  // CheckList Form
  selectedAssignments:any;
  clientAssignment :any;
  showClientCheckList(){
    this.selectedAssignments = [];
    this.clientAssignment =[];
    this.formObj.value.partners.forEach((partner, partnerKey) => {
      console.log(partner);
      partner.assignments.forEach((assignment, assignmentkey) => {
        var index = this.selectedAssignments.findIndex(item => item.id === assignment.id)
        if(index==-1){
          var obj = { partnerId: partner.id, assignment: {...assignment}, clientAssignmentChecklist:[...this.checkList]}
          this.selectedAssignments.push(assignment);
          this.clientAssignment.push(obj);
        }
      });
    });
    console.log(this.clientAssignment);
    this.initClientChecklistForm();
    this.showChecklist = true;
  }

  // Create Checklist form
  clientChecklistForm : any;
  initClientChecklistForm(){
    this.clientChecklistForm =  this.fb.group({
      clientAssignment:this.fb.array([])
    });

    this.clientAssignment.forEach((assignment, key) => {
      (<FormArray>this.clientChecklistForm.get('clientAssignment')).push(this.getclientAssignmentFormObject(assignment));
    });
  };

  clientAssignmentFormObject : any;
  getclientAssignmentFormObject(obj){
    this.clientAssignmentFormObject = this.fb.group({
      assignment: this.fb.group({
        id: [obj.assignment.id, Validators.required],
        name: [obj.assignment.name, Validators.required],
        isCheckListRequired : [obj.assignment.isCheckListRequired, Validators.required],
      }),
      clientAssignmentChecklist : this.fb.array([]),
    });

    var partnerIndex = this.partnerList.findIndex(item => item.id === obj.partnerId);
    var partner = this.partnerList[partnerIndex];

    let isSignControl = new FormControl(null);
    let signDateControl = new FormControl('');
    let partnerControl = new FormControl(partner.firstName+' '+partner.middleName+' '+partner.lastName);

    (<FormGroup>this.clientAssignmentFormObject).addControl('isSign',isSignControl);
    (<FormGroup>this.clientAssignmentFormObject).addControl('signDate',signDateControl);
    (<FormGroup>this.clientAssignmentFormObject).addControl('partner',partnerControl);

    if(obj.assignment.isCheckListRequired){
      isSignControl.setValidators(Validators.required);
      signDateControl.setValue(new Date());
    }else{
      signDateControl.setValue(new Date());
    }

    obj.clientAssignmentChecklist.forEach((checklist, key) => {
      (<FormArray>this.clientAssignmentFormObject.get('clientAssignmentChecklist')).push(this.getChecklistObject(checklist));
    })
    return this.clientAssignmentFormObject;
  };

  checklistObject : any;
  getChecklistObject(checklist){
    this.checklistObject = this.fb.group({
      id: [checklist.id],
      questionNo: [checklist.questionNo],
      question: [checklist.question],
      isRequired: [checklist.isRequired],
      remark: [checklist.remark],
    });
    return this.checklistObject;
  };

  getJsonForSave(){
    let data:any;
    data = { ...this.formObj.value};
    data.partners = [];
    data.clientAssignment=[];
    this.formObj.value.partners.forEach((partner, partnerKey) => {
      const part = { "assignment": {}, "id": partner.id};
      partner.assignments.forEach((assignment, assignmentkey) => {
      part.assignment = assignment;
      data.partners.push(part);
      });
    });

    this.clientChecklistForm.value.clientAssignment.forEach((clientAssignment, cakey) => {

      if(clientAssignment.isSign){
        var obj ={
          "assignment":{
            "id" : clientAssignment.assignment.id,
            "name" : clientAssignment.assignment.name
          },
          "clientAssignmentChecklist":[]
        }

        clientAssignment.clientAssignmentChecklist.forEach((checklist, ckey) => {
          var checklistObj = {
            "id": checklist.id,
            "isRequired": checklist.isRequired,
            "remark": checklist.remark
           }
           obj.clientAssignmentChecklist.push(checklistObj);
        });

        data.clientAssignment.push(obj);
      }
    })
    console.log(data.clientAssignment);
    return JSON.stringify(data)  ;
  }

  getInvalidChecklistTabIndex(){
      var invalidKey=-1;
      var checklist = this.clientChecklistForm.value;
      this.clientChecklistForm.value.clientAssignment.forEach((element, key) => {
      if(element.assignment.isCheckListRequired){
      console.log(element,key)
      invalidKey = key;
      }
      })
      return invalidKey;
  }

  // Events
  onOkBtnClick(){
    console.log(this.formObj);
    console.log(this.formObj.value);
    console.log(this.assignmentList);
    this.formSubmitted=true;
    this.logValidationErrors(this.formObj);
    this.validateAssignments();
    // let jsonData = this.getJsonForSave();
    if(this.formObj.valid){
      this.showClientCheckList();
    }
  }

  onBackBtnClick(){
    this.showChecklist = false;
  }

  // Client
  onSaveClick(){
  console.log(this.clientAssignment);
  console.log(this.clientChecklistForm);
  console.log(this.clientChecklistForm.value);
  if(this.clientChecklistForm.valid){
      const jsonData = this.getJsonForSave();
      console.log(jsonData);
      this.masterDataService.saveClient(jsonData)
      .subscribe(resp => {
        console.log(resp);
        this.closeModal();
        this.changeModalFormObjList(resp);
        this.commonMessageService.swalAlertWithIcon('','Saved Successfully!','success')
      });
    }else{
      // var invalidTabIndex = this.getInvalidChecklistTabIndex();
      // if(invalidTabIndex>=0){
      //   this.tabsetChecklist.select('tab-selectbyid_'+invalidTabIndex);
      // }
    }
  }

  onDeleteClick(item){
    console.log(item);
    Swal.fire({
      text: 'Are you sure you want to remove?',
      showCancelButton: true,
      confirmButtonText: 'Ok',
      confirmButtonColor:'#800000'
    }).then((result) => {
      if (result.isConfirmed) {
        this.formStatus = 'delete';
        this.masterDataService.deleteClient(item.id)
        .subscribe(resp => {
          console.log(resp);
          this.changeModalFormObjList(item);
          this.commonMessageService.swalAlertWithIcon('','Deleted Successfully!','success')
        })
      }
    })
  }

  // Edit Client
  onEditClick(formObj){
    console.log(formObj);
    this.viewModalFormObj(formObj);
  }

  viewModalFormObj(formObj){
    this.masterDataService.viewClient(formObj.id)
    .subscribe(resp => {
      console.log(resp);
      this.setValueToModalForm(resp);
      this.openModal('edit');
    })
  }

  setValueToModalForm(modalObj){
    console.log(modalObj)
    const ediaryStatusIndex = this.ediaryStatusList.findIndex(item => item.id == modalObj.ediaryStatus.id);
    const legalStatusIndex = this.legalStatusList.findIndex(item => item.id == modalObj.legalStatus.id);
    const branchIndex = this.branchList.findIndex(item => item.id == modalObj.branch.id);
    const sectorIndex = this.sectorList.findIndex(item => item.id == modalObj.sector.id);

    this.formObj.patchValue({
        id : modalObj.id,
        name : modalObj.name,
        email : modalObj.email,
        pan : modalObj.pan,
        address: modalObj.address,
        alias : modalObj.alias,
        chargeableToClient : modalObj.chargeableToClient,
        gstNumber : modalObj.gstNumber,
        principalPlaceOfBusiness : modalObj.principalPlaceOfBusiness,
        ediaryStatus : this.ediaryStatusList[ediaryStatusIndex],
        legalStatus : this.legalStatusList[legalStatusIndex],
        branch : this.branchList[branchIndex],
        sector : this.sectorList[sectorIndex],
    });
    (this.formObj.controls['partners']).clear();
    (this.formObj.controls['clientLocations']).clear();
    this.initPartnerNlocationForEdit(modalObj);

  }


  initPartnerNlocationForEdit(modalObj){
  var selectedPartnerList=[];
  var newObj={id:0,assignments:[]}
  modalObj.partners.forEach((element, key) => {
      var index = selectedPartnerList.findIndex(item => item.id === element.id);
      if(index>=0){
        var existingObj = selectedPartnerList[index];
        var assignIndex = this.assignmentList.findIndex(item => item.id === element.assignment.id);
        existingObj.assignments.push({...this.assignmentList[assignIndex]});
      }else{
        newObj={id:0,assignments:[]};
        newObj = {id:element.id,assignments:[]};
        var assignIndex = this.assignmentList.findIndex(item => item.id === element.assignment.id);
        newObj.assignments.push({...this.assignmentList[assignIndex]});
        selectedPartnerList.push(newObj);
      }
  });

  selectedPartnerList.forEach((element, key) => {
    this.addPartnerFormGroupInEdit(element);
  })

  modalObj.clientLocations.forEach((element, key) => {
    this.addLocationFormGroupInEdit(element);
  })

}
partner : FormGroup;
addPartnerFormGroupInEdit(partner) {
  (<FormArray>this.formObj.get('partners')).push(this.fb.group({
    id: [partner.id, Validators.required],
    assignments: [partner.assignments, Validators.required]
   }));
}

location : FormGroup;
addLocationFormGroupInEdit(location) {
  (<FormArray>this.formObj.get('clientLocations')).push(
    this.fb.group({
      id: [location.id, Validators.required],
      distance: [location.distance, Validators.required],
      amount: [location.amount, Validators.required]
    })
  );
}






//Setting
changeModalFormObjList(modalFormObj){
  if(this.formStatus=='add'){
    this.formObjList.push(modalFormObj);
  }
  if(this.formStatus=='edit'){
    var index = this.formObjList.findIndex(item => item.id === modalFormObj.id)
    this.formObjList.splice(index, 1, modalFormObj);
  }
  if(this.formStatus=='delete'){
    var index = this.formObjList.findIndex(item => item.id === modalFormObj.id)
    this.formObjList.splice(index, 1);
  }
}



  logValidationErrors(group: FormGroup = this.formObj): void {
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);

      this.formErrors[key] = '';
      if (abstractControl && !abstractControl.valid && this.formSubmitted) {
        const messages = this.formValidationMessages[key];

        for (const errorKey in abstractControl.errors) {
          if (errorKey) {
            this.formErrors[key] += messages[errorKey] + ' ';
          }
        }
      }

      if (abstractControl instanceof FormGroup) {
        this.logValidationErrors(abstractControl);
      }

      // if (abstractControl instanceof FormArray) {
      //   for (const control of abstractControl.controls) {
      //     if (control instanceof FormGroup) {
      //       this.logValidationErrors(control);
      //     }
      //   }
      // }
    });
  }

}
